module.exports = __webpack_public_path__ + "img/openapp.ba4e7719.png";